import React, { memo } from 'react';
import { ReactComponent as IconSVG } from '../../images/logo.svg';
import styles from './index.module.scss';
import { FooterMarks } from '../FooterMarks/FooterMarks';
import { FOOTER_MARKS } from '../../constants';
import { Button } from '../../shared/components/Button';

export const Footer = memo(function Footer({
  link,
  price,
}: {
  link: string | null;
  price: number | null;
}) {
  return (
    <section className={styles.footer_section}>
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <IconSVG className={styles.pets} />
        </div>

        <div className={styles.footer_marks}>
          {FOOTER_MARKS.map((mark, i) => (
            <FooterMarks key={mark} mark={mark} />
          ))}
        </div>
        <div className={styles.button_wrapper}>
          <Button link={link} price={price} btnClassName="orange_btn" text="Купить курс" />
        </div>
      </div>
    </section>
  );
});
